import { nextTick, PropType, reactive, watch } from 'vue';
import BaseSetupService from '@/setup/BaseSetupService';
import TempWorkerAvailabilityEntity from '@/entity/TempWorkerAvailabilityEntity';
import { Bus } from '@orion.ui/orion';

type Props = SetupProps<typeof UserProfileSpecificAvailabilitiesAsideNewSetupService.props>

export default class UserProfileSpecificAvailabilitiesAsideNewSetupService extends BaseSetupService<Props> {
	static readonly props = {
		availabilityEntity: {
			type: Object as PropType<TempWorkerAvailabilityEntity>,
			required: true as const,
		},
		day: {
			type: Date,
			default: undefined,
		},
	};

	protected _aside?: OrionAside;
	protected readonly entity = new TempWorkerAvailabilityEntity();
	private readonly state = reactive({
		period: this.props.day
			? {
				...this.props.day.getWeekDates(),
				weekNumber: this.props.day.getWeekNumber(),
			}
			: undefined as Undef<Orion.DateRange>,
	});

	get period () { return this.state.period; }
	set period (val) {this.state.period = val;}

	get specificAvailabilityEntity () {
		return this.entity;
	}

	constructor (props?: Props, _aside?: OrionAside) {
		super(props);
		this._aside = _aside;

		watch(() => this.period, (val) => {
			this.entity.from = val?.start?.toPost();
			this.entity.to = val?.end?.toPost();
		});
	}

	protected async onBeforeMountAsync () {
		this.props.availabilityEntity.isNew
			? this.entity.assignData({
				...this.props.availabilityEntity.defaultAvailabilities,
				to: undefined,
				from: undefined,
			})
			: this.entity.assignData(this.props.availabilityEntity.specificDefaultAvailabilities);

		nextTick(() => {
			if (this.entity.to && this.entity.from) {
				this.period = {
					start: new Date(this.entity.from),
					end: new Date(this.entity.to),
					weekNumber: new Date(this.entity.from).getWeekNumber(),
					year: new Date(this.entity.from).getFullYear(),
				};
			} else if (this.state.period) {
				this.entity.from = this.state.period.start?.toPost();
				this.entity.to = this.state.period.end?.toPost();
			}
		});
	}

	weekPickerCustomValueDisplay (val: any) {
		if (val) {
			return `Semaine ${val.weekNumber} &nbsp;
			<small class="text--grey-dark">Du ${val.start.toReadable('$DD/$MM/$YYYY')} au ${val.end.toReadable('$DD/$MM/$YYYY')}</small>`;
		}
	}

	async addAsync () {
		this._aside?._loader()?.show(`Enregistrement d'une disponibilité particulière...`);
		const res = await this.entity.addSpecificAvailabilityAsync();
		Bus.emit('add-specific-availability', res);
		Bus.emit(`DashboardTempWorkerCalendarSetupService:specificAvailabilityAdded`, res);
		this._aside?.trigger('add', res);
		this._aside?._loader()?.hide();
		this._aside?.close();
	}

	async updateAsync () {
		this._aside?._loader()?.show(`Sauvegarde des modifications...`);
		const res = await this.specificAvailabilityEntity.updateSpecificAvailabilityAsync();
		Bus.emit(`DashboardTempWorkerCalendarSetupService:specificAvailabilityUpdated`, res);
		this.props.availabilityEntity.assignData(res);
		this._aside?._loader()?.hide();
		this._aside?.close();
	}
}
